const Calendar2 = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-calendar"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-calendar"
      viewBox="0 0 16 15"
      width={_width}
      {...props}
    >
      <path
        d="M5.5 1.25V3.125"
        stroke="#7B7F82"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.5 1.25V3.125"
        stroke="#7B7F82"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.6875 5.68127H13.3125"
        stroke="#7B7F82"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.625 5.3125V10.625C13.625 12.5 12.6875 13.75 10.5 13.75H5.5C3.3125 13.75 2.375 12.5 2.375 10.625V5.3125C2.375 3.4375 3.3125 2.1875 5.5 2.1875H10.5C12.6875 2.1875 13.625 3.4375 13.625 5.3125Z"
        stroke="#7B7F82"
        stroke-width="0.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.3092 8.5625H10.3148"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.3092 10.4375H10.3148"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.99718 8.5625H8.00279"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.99718 10.4375H8.00279"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.68394 8.5625H5.68956"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.68394 10.4375H5.68956"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Calendar2;
